<template>
	<div>
		<div class="footer">
			<slot></slot>
		</div>
		<div class="footer-spacer"></div>
	</div>
</template>
<script>
export default {
	methods: {},
}
</script>

<style scoped>
.footer {
	height: 64px;
	position: fixed;
	bottom: 0px;
	left: 0px;
	right: 0px;
	display: flex;
	justify-content: center;
	background-color: #fff;
}

.footer .btn-add {
	width: 68px;
	height: 68px;
	border-radius: 34px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: -24px;
}
.footer-spacer {
	height: 64px;
	width: 100%;
}
</style>
